import Vue from 'vue';
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL + process.env.VUE_APP_VERSION,
});
// api.defaults.headers.common['Authorization'] = 'Token' + localStorage.getItem('authToken');

api.interceptors.response.use(
    (res) => res.data,
    (err) => {
        throw err.response.data;
    },
);

Vue.prototype.$api = api;

// ---------
// Mock API
// ---------

const mockApi = axios.create({
    baseURL: '/mock-api/',
});

mockApi.interceptors.response.use(
    (res) => res.data,
    (err) => {
        throw err.response.data;
    },
);

Vue.prototype.$mockApi = mockApi;
